export default __webpack_public_path__ + "static/media/adi-kopolvich.9c4ce9b1.png";